export const debounce = (func, delay) => {
  let timeout;
  const debouncedFunction = (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };

  debouncedFunction.cancel = () => clearTimeout(timeout);

  return debouncedFunction;
};
